// extracted by mini-css-extract-plugin
export default {"sortIcon":"app-portainer-components-datatables-components-TableHeaderCell-module__sort-icon"};